__turbopack_context__.v({
  "divider": "report-abuse-module-scss-module__eorGKW__divider",
  "report-abuse-full-width": "report-abuse-module-scss-module__eorGKW__report-abuse-full-width",
});
